// extracted by mini-css-extract-plugin
export default {"copilotCard":"CopilotCodingAgentStatus-module__copilotCard--Kceg7","arrowBoth":"CopilotCodingAgentStatus-module__arrowBoth--ojdJ2"};